import { cn } from "@/lib/utils";

import LogoFull from "@/assets/logo_full.png";
import LogoMark from "@/assets/logo_icon.png";
import LogoFullWhite from "@/assets/logo_full_w.png";
import LogoMarkWhite from "@/assets/logo_icon_w.png";

type LogoVariant = "full" | "mark";
type LogoTone = "auto" | "white";

interface LogoProps {
  variant?: LogoVariant;
  tone?: LogoTone;
  /**
   * Rendered height in pixels.
   * Width is kept proportional by the SVG itself.
   */
  size?: number;
  alt?: string;
  className?: string;
}

export function Logo({
  variant = "full",
  tone = "auto",
  size = 36,
  alt = "NAGRA Venturi",
  className,
}: LogoProps) {
  const lightSrc = variant === "full" ? LogoFull : LogoMark;
  const darkSrc = variant === "full" ? LogoFullWhite : LogoMarkWhite;

  if (tone === "white") {
    return (
      <img
        src={darkSrc}
        alt={alt}
        draggable={false}
        className={cn("block h-auto w-auto max-w-none shrink-0 select-none", className)}
        style={{ height: size }}
      />
    );
  }

  return (
    <>
      <img
        src={lightSrc}
        alt={alt}
        draggable={false}
        className={cn("block h-auto w-auto max-w-none shrink-0 select-none dark:hidden", className)}
        style={{ height: size }}
      />
      <img
        src={darkSrc}
        alt={alt}
        draggable={false}
        className={cn("hidden h-auto w-auto max-w-none shrink-0 select-none dark:block", className)}
        style={{ height: size }}
      />
    </>
  );
}
